import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-j-small', 'LetterJSmall', [["path",{"d":"M10 8h4v6a2 2 0 1 1 -4 0","key":"svg-0"}]]);